module.exports = __webpack_public_path__ + "assets/img/17_1011_big.f3ca7759.jpg";